import Svg, { Path } from 'react-native-svg';
import { ColorValue } from 'react-native';

export interface Props {
  borderRadius: number;
  fill: ColorValue;
  height: number;
  width: number;
}

export const CornerArcs: React.FC<Props> = ({
  borderRadius,
  fill,
  height,
  width,
}) => {
  const radius = Math.min(borderRadius, width / 2, height / 2);

  const topLeft = `
    M0,${radius}
    A${radius},${radius} 0 0 1 ${radius},0
    L${radius},0
    L0,0
    Z
  `;

  const topRight = `
    M${width - radius},0
    A${radius},${radius} 0 0 1 ${width},${radius}
    L${width},0
    L${width - radius},0
    Z
  `;

  const bottomRight = `
    M${width},${height - radius}
    A${radius},${radius} 0 0 1 ${width - radius},${height}
    L${width},${height}
    L${width},${height - radius}
    Z
  `;

  const bottomLeft = `
    M${radius},${height}
    A${radius},${radius} 0 0 1 0,${height - radius}
    L0,${height}
    L${radius},${height}
    Z
  `;

  return (
    <Svg height={height} width={width}>
      <Path d={topLeft} fill={fill} />
      <Path d={topRight} fill={fill} />
      <Path d={bottomRight} fill={fill} />
      <Path d={bottomLeft} fill={fill} />
    </Svg>
  );
};
